import React from 'react';

export default function CallerBanner({ contact }) {
  if (!contact) return null;

  const { name, company, phone, email, tags, source, opportunities } = contact;
  const hasIdentity = name || company;
  const topOpp = opportunities?.length > 0 ? opportunities[0] : null;

  return (
    <div className="caller-banner">
      <div className="caller-banner-identity">
        {hasIdentity ? (
          <>
            {name && <span className="caller-banner-name">{name}</span>}
            {company && <span className="caller-banner-company">{company}</span>}
          </>
        ) : (
          <span className="caller-banner-name">{phone || 'Unknown Caller'}</span>
        )}
      </div>

      <div className="caller-banner-details">
        {hasIdentity && phone && <span className="caller-banner-detail">{phone}</span>}
        {email && <span className="caller-banner-detail">{email}</span>}
        {source && <span className="caller-banner-detail caller-banner-source">{source}</span>}
      </div>

      {Array.isArray(tags) && tags.length > 0 && (
        <div className="caller-banner-tags">
          {tags.slice(0, 5).map((tag) => (
            <span key={tag} className="caller-banner-tag">{tag}</span>
          ))}
          {tags.length > 5 && <span className="caller-banner-tag caller-banner-tag-more">+{tags.length - 5}</span>}
        </div>
      )}

      {topOpp && (
        <div className="caller-banner-opp">
          <span className="caller-banner-opp-name">{topOpp.name}</span>
          {topOpp.stage && <span className="caller-banner-opp-stage">{topOpp.stage}</span>}
          {topOpp.value && <span className="caller-banner-opp-value">${Number(topOpp.value).toLocaleString()}</span>}
        </div>
      )}
    </div>
  );
}
